'use client';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
export class SmartErrorBoundary extends React.Component {
    static propTypes = {
        boundaryName: PropTypes.string,
        fallback: PropTypes.node,
        children: PropTypes.node.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: undefined,
        };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error(`[SmartErrorBoundary] ${this.props.boundaryName ?? 'Boundary'} error:`, error, info);
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? (_jsx("div", { className: "smart-error-boundary-fallback", children: _jsxs("p", { children: ["Sorry, something went wrong loading", ' ', this.props.boundaryName ?? 'this section', "."] }) }));
        }
        return this.props.children;
    }
}
